import client from "./axiosConfig";

// Leave Calender
export const getLeaveCalendar = (params) => {
    const config = {
        url: `/leave_manager/leave-calendar/`,
        method: "GET",
        params,
    };
    const response = client(config);
    return response;
};

export const createLeave = (data) => {
    const config = {
        url: `/leave_manager/leave-calendar/`,
        method: "POST",
        data
    }
    const response = client(config);
    return response;
}

export const deleteLeave = (leave_id) => {
    const config = {
        url: `/leave_manager/leave-calendar/${leave_id}/`,
        method: 'DELETE',
    }
    const response = client(config);
    return response;
}

export const getLeaveDetailsById = (leave_id) => {
    const config = {
        url: `/leave_manager/leave-calendar/${leave_id}/`,
        method: 'GET'
    }
    const response = client(config);
    return response;
}


//Leave Requests
export const getLeaveRequestList = (params) => {
    const config = {
        url: `/leave_manager/leave-request/`,
        method: "GET",
        params,
    };
    const response = client(config);
    return response;
};

export const createLeaveRequest = (data) => {
    const config = {
        url: `/leave_manager/leave-request/`,
        method: "POST",
        data
    }
    const response = client(config);
    return response;
}

export const deleteLeaveRequest = (leave_id) => {
    const config = {
        url: `/leave_manager/leave-request/${leave_id}/`,
        method: 'DELETE',
    }
    const response = client(config);
    return response;
}

export const getLeaveRequestDetailsById = (leave_id) => {
    const config = {
        url: `/leave_manager/leave-request/${leave_id}/`,
        method: 'GET'
    }
    const response = client(config);
    return response;
}

export const updateLeaveRequest = (id, data) => {
    const config = {
        url: `/leave_manager/leave-request/${id}/`,
        method: 'PATCH',
        data
    }
    const response = client(config);
    return response;
}

export const getLeaveApprovals = (params) => {
    const config = {
        url: `/leave_manager/leave-approvals/`,
        method: "GET",
        params
    }
    const response = client(config);
    return response;
}

export const approveLeaves = (leave_id, data) => {
    const config = {
        url: `/leave_manager/leave-approvals/${leave_id}/update-status/`,
        method: "PATCH",
        data
    }
    const response = client(config);
    return response;
}

export const getLeaveUsers = (params) => {
    const config = {
        url: `/leave_manager/leave-approvals/reporting-users/`,
        method: "GET",
        params
    }
    const response = client(config);
    return response;
}

//Leave Summary
export const getLeaveSummary = (params) => {
    const config = {
        url: `/leave_manager/leave-summary/`,
        method: "GET",
        params
    }
    const response = client(config);
    return response;
}

export const getLeaveSummaryById = (id) => {
    const config = {
        url: `/leave_manager/leave-summary/${id}/`,
        method: "GET",
    }
    const response = client(config);
    return response;
}

export const createLeaveSummary = (data) => {
    const config = {
        url: `/leave_manager/leave-summary/`,
        method: "POST",
        data
    }
    const response = client(config);
    return response;
}

export const refreshLeaveSummary = (data) => {
    const config = {
        url: `leave_manager/leave-summary/refresh-summary/`,
        method: "POST",
        data
    }
    const response = client(config);
    return response;
}

//Leave Credit-Debit
export const getLeaveCreditDebit = (params) => {
    const config = {
        url: `/leave_manager/leave-credit-debit/`,
        method: "GET",
        params
    }
    const response = client(config);
    return response;
}

export const createLeaveCreditDebit = (data) => {
    const config = {
        url: `/leave_manager/leave-credit-debit/`,
        method: "POST",
        data
    }
    const response = client(config);
    return response;
}

export const getLeaveCreditDebitById = (id) => {
    const config = {
        url: `/leave_manager/leave-credit-debit/${id}/`,
        method: "GET",
    }
    const response = client(config);
    return response;
}